/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import Illustration from '../../assets/images/illustration.png'
import './index.css'
import { MAX_RESEND_EMAIL, RESEND_EMAIL_INTERVAL } from '../../constants/common';

const Verification = () => {
    const location = useLocation();
    const { resendAccessCode, email_id } = location.state || {};
    // const resendAccessCode = "test";
    // const email_id = "aayush.joshi+test@screen-magic.com"

    const signup_url = process.env.REACT_APP_SIGNUP_PAGE_URL;
    const apiResendEmailVerification = process.env.REACT_APP_RESEND_API;

    const [retry_count, setRetryCount] = useState(0)
    const [errMsg, setErrMsg] = useState('')
    const [disableResend, setDisableResend] = useState(false)
    const [remainingTime, setRemainingTime] = useState(RESEND_EMAIL_INTERVAL)
    const responseTokenForVerification = resendAccessCode
    if (!responseTokenForVerification) {
        window.location.replace(signup_url)
    }

    const resendEmail = async () => {
       setErrMsg('')
        if (retry_count >= MAX_RESEND_EMAIL) {
            setErrMsg('Max Retry count exceeded')
            setDisableResend(true)
            return
        }
        if (!disableResend) {
            setRemainingTime(RESEND_EMAIL_INTERVAL)
            setRetryCount(retry_count + 1)
            setDisableResend(true)
            try {
              const data = {
                token: resendAccessCode,
              };
              // eslint-disable-next-line no-unused-vars
              let res = await fetch(`${apiResendEmailVerification}`, {
                method: "POST",
                body: JSON.stringify(data),
              });
            } catch (error) {
                if (error?.res?.status === 401) {
                    setRemainingTime(0)
                    setDisableResend(true)
                    setErrMsg('Max Retry count exceeded')
                } else {
                    setErrMsg(
                        'Something went wrong, please try after some time'
                    )
                }
            }
        }
    }
    const startTimer = () => {
        const timerInterval = setInterval(() => {
            setRemainingTime((prevRemainingTime) => {
                if (prevRemainingTime > 1) {
                    return prevRemainingTime - 1
                } else {
                    setDisableResend(false)
                    setErrMsg('')
                    clearInterval(timerInterval)
                    return 0
                }
            })
        }, 1000)
    }

    useEffect(() => {
        if (disableResend && remainingTime) {
            startTimer()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disableResend])

    return (
        <div className="verification-container">
        <div className="logo-container">
          <a href="/trial" className="magic-logo-link">
            <img src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg" alt="logo" />
          </a>
        </div>
        <div className="content-container">
          <div className="illustration-block"
            style={{
                backgroundImage: `url(${Illustration})`,
            }}
          >
          </div>
          <h3 className="heading">Account with this email already exists.</h3>
          <h3 className="heading-verify-text">Verify your email to proceed</h3>
          <p>
            We've sent you an email at{' '}
            <span className="email-highlight">{email_id}</span> with a magic link. <br/>
            <span className="click-here-text">Click on the link to verify your email and sign in to SMS-Magic.</span>
          </p>
          <p className="spam-check">
            Can't find your magic link? Check your spam folder!
          </p>
          <p className="resend-link">
            Haven't received the email yet? <span className="resend-text">
                    <a
                      onClick={resendEmail}
                      className={
                        disableResend && retry_count <= MAX_RESEND_EMAIL
                        ? 'pointer-events-none-resend'
                        : 'text-blue-500 underline cursor-pointer'
                      }
                    >
                    Resend
                    </a>
                  </span>{' '}
                    the link{' '}
                    {disableResend && remainingTime
                        ? `in ${remainingTime}s`
                        : ''}
          </p>
          {errMsg && (
              <div className="custome-container">
                  <p className="error-message">{errMsg}</p>
              </div>
          )}
        </div>
      </div>  
    )
}

export default Verification
